import { render, staticRenderFns } from "./SolicitudesHistoricasView.html?vue&type=template&id=63a536b8&external"
import script from "./SolicitudesHistoricasView.vue?vue&type=script&lang=js"
export * from "./SolicitudesHistoricasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports